<form name="form" [formGroup]="form">

  <div class="cdk-barra-pesquisa">
    <div class="sm:hidden flex items-center">
      <button (click)="routeSearch()" mat-icon-button class="custom-search-button"
        aria-label="Pesquisar por">
        <mat-icon svgIcon="mat_outline:manage_search"></mat-icon>
      </button>
    </div>

    <div class="barra-pesquisa-final">

      @if (isUserConsultivo) {
        <ng-template #buscaComponent></ng-template>
      }
      
      <!-- /* ALTERADO PELA PGE-RS: ajustes visuais em labels (Pesquisar por) */ -->
      <div class="cdk-barra-pesquisa-content xs:hidden">
        <div class="form-field-flex">

          <!-- /* ALTERADO PELA PGE-RS: button ocultado quando o X é exibido. */ -->
          @if (!form.get('processo')?.value) {
            <button mat-icon-button            
              class="custom-search-button"
              aria-label="Pesquisar por"
              [matTooltip]="'Pesquisar por ' + this.searchFieldName"
              [matMenuTriggerFor]="menuBusca">
              <mat-icon svgIcon="mat_outline:manage_search"></mat-icon>
            </button>          
          }          

          <!-- /* ALTERADO PELA PGE-RS: button X incluído */ -->
          @if (form.get('processo')?.value) {
            <button mat-icon-button                 
              class="custom-search-button"
              matTooltip="Limpar" 
              (click)="limparCampo()">
              <mat-icon>close</mat-icon> 
            </button>            
          }          

          <!-- /* ALTERADO PELA PGE-RS: remoção de 'rápida de processos ' */ -->
          <div class="input-container">
            <label [ngClass]="{'floating': form.get('processo')?.value}"
              class="input-label"
              for="processoInput">
              Pesquisar por {{ searchFieldName }}
            </label>
            <!-- /* ALTERADO PELA PGE-RS: adicionado spellcheck="false" ' */ -->
            <input id="processoInput" spellcheck="false"
              class="input-field flex grow"
              formControlName="processo"
              (focus)="onFocus()"
              (blur)="onBlur()"
              (input)="onInput()"
              matInput
              [matAutocomplete]="processoSearch.autocomplete()">
          </div>
          <cdk-processo-search-autocomplete
            #processoSearch="processoSearchAutocomplete"
            [searchField]="searchField"
            [openBlank]="true"
            [control]="form.get('processo')"
            [pagination]="processoPagination">
          </cdk-processo-search-autocomplete>
        </div>
      </div>
    </div>

  </div>
  <mat-menu #menuBusca="matMenu" class="menu-busca" [overlapTrigger]="false" xPosition="before">
     <!-- /* ALTERADO PELA PGE-RS: ajustes visuais. */ -->
    <div class="m-1">
      <div class="custom-search-header" style="border-bottom: 1px solid lightgray; margin-bottom: 8px;">
        <span style="padding-bottom: 6px;">Pesquisar por:</span>
      </div>
      
      <!-- ALTERADO PELA PGE-RS: adicionado https://gitlab01.pgers.intra.rs.gov.br/supp/supp-administrativo-frontend/-/issues/245  -->
      <div class="campo" (click)="selecionaCampo('tarefa', 'Tarefa', 'administrativo')"
        [ngClass]="{'selected': searchField === 'tarefa'}">
        <span>Tarefa</span>
        @if (searchField === 'TAREFA') {
          <mat-icon class="text-base text-primary w-[24px] h-[24px] min-w-[14px] min-h-[14px]"
            >check
          </mat-icon>
        }
      </div>
     
      <div class="campo" (click)="selecionaCampo('NUP', 'NUP', 'administrativo')"
        [ngClass]="{'selected': searchField === 'NUP'}">
        <span>NUP</span>
        @if (searchField === 'NUP') {
          <mat-icon class="text-base text-primary w-[24px] h-[24px] min-w-[14px] min-h-[14px]"
            >check
          </mat-icon>
        }
      </div>
      <div class="campo" (click)="selecionaCampo('outroNumero', 'Outro Número', 'administrativo')"
        [ngClass]="{'selected': searchField === 'outroNumero'}">
        <span>Outro Número</span>
        @if (searchField === 'outroNumero') {
          <mat-icon class="text-base text-primary w-[24px] h-[24px] min-w-[14px] min-h-[14px]"
                    style="font-size: 24px !important;"
            >check
          </mat-icon>
        }
      </div>

      <ng-template #dynamicComponent></ng-template>
    </div>
  </mat-menu>
</form>
